import { ContentTypeEnum } from '@/enums/axios'
import request from '@/utils/axios'
import type { CustomerManage } from '@/apis/interface/customerManage'

const jsonHeaderConfig = {
  headers: {
    'Content-Type': ContentTypeEnum.JSON
  }
}

// 获取部门架构-无数据权限
export const getDepartmentList = (data?: any) =>
  request.post('/admin/department/tenant/tree', data, jsonHeaderConfig)

// 根据部门ID查询用户列表-无数据权限
export const getUserByDepId = (data?: any) =>
  request.get('/admin/user/listByDepartment', data, jsonHeaderConfig)

// 查询租户角色列表-无数据权限
export const getRoleList = (data?: any) =>
  request.get('/admin/role/list/tenant', data, jsonHeaderConfig)

// 分页查询租户用户列表-无数据权限
export const getMemberList = (data?: any) =>
  request.post('/admin/user/page/tenantUser', data, jsonHeaderConfig)

// 批量选择ID列表-无数据权限
export const batchSelectOrderIdList = (data?: any) =>
  request.post('/crm/track/normal/batchSelectOrderIdList', data, jsonHeaderConfig)

// 跟进角色获取人员-无数据权限
export const getMemberByRole = (data?: any) =>
  request.get('/admin/user/listByRole', data, jsonHeaderConfig)

// 获取部门架构-数据权限
export const getDepartmentListCrm = (data?: any) =>
  request.post('/crm/member/department/tenant/tree', data, jsonHeaderConfig)
// 根据部门ID查询用户列表-数据权限
export const getUserByDepIdCrm = (data?: any) =>
  request.get('/crm/member/user/listByDepartment', data, jsonHeaderConfig)
// 根据角色ID查询用户列表-数据权限
export const getMemberByRoleCrm = (data?: any) =>
  request.get('/crm/member/user/listByRole', data, jsonHeaderConfig)
// 查询租户角色列表-数据权限
export const getRoleListCrm = (data?: any) =>
  request.get('/crm/member/role/list/tenant', data, jsonHeaderConfig)
// 分页查询租户用户列表-数据权限
export const getMemberListCrm = (data?: any) =>
  request.post('/crm/member/user/page/tenantUser', data, jsonHeaderConfig)

// 人员部门组件数据查询接口

export const getComponentTree = (data?: CustomerManage.ComponentTree, headers: any = undefined) => {
  return request.post(
    '/crm-report/member/component/tree',
    data,
    headers ? { headers: { ...jsonHeaderConfig, ...headers } } : jsonHeaderConfig,
    { ignoreCancelToken: true }
  )
}

// 数据穿透获取 异地客户标签ID
export const getDefaultTagInfo = (data?: any) =>
  request.post(
    '/crm/config/saas_customer_tag_group_config/getDefaultTagInfo',
    data,
    jsonHeaderConfig
  )
// 获取渠道（客户来源）列表
export const queryAllChannelByTenantIdApi = (data?: any) =>
  request.post('/crm/openSeaAutoAssignRule/queryAllApiSource', data)
// 根据客户名称/ID/联系电话
export const searchOrderInfoApi = (data?: any) =>
  request.get('/crm-report/track/normal/searchOrderInfo', data)
// 保存列宽信息
export const saveColumnWidthApi = (data?: any, headers: any = undefined) =>
  request.post(
    '/crm/custom_table_config/save',
    data,
    headers ? { headers: { ...jsonHeaderConfig, ...headers } } : jsonHeaderConfig
  )
// 获取列宽信息
export const getColumnWidthApi = (data?: any, headers: any = undefined) =>
  request.post(
    '/crm/custom_table_config/list',
    data,
    headers ? { headers: { ...jsonHeaderConfig, ...headers } } : jsonHeaderConfig,
    { ignoreCancelToken: true }
  )
